module.exports = __webpack_public_path__ + "static/media/FDYaXr_VQBIIlP0.07bd034f.webp";